import { Box, Card, FormHelperText, Grid } from "@mui/material"
import { AlertDialog, DebugBox, ReactHooksFormWrapper, SelectRequiredControl, TextAreaRequiredControl, TextFieldControl } from "@northpowerdev/np-react-utils"
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useFetchJson from "../../../data/useFetchJson";
import { RadioGroupRequiredControl } from "../../styled/RadioGroupControl";

const RemedialWorkCrew = [
    { key: 'cutaway', value: 'Cut Away Only', label: 'Cut Away Only' },
    { key: 'cutawayHardware', value: 'Cut Away / Hardware', label: 'Cut Away / Hardware' },
]

const yesNoOptions = [
    { key: 'yes', value: 'Yes', label: 'Yes' },
    { key: 'no', value: 'No', label: 'No' },
]

const initialFormState = {
    // Work instructions
    workers: null,                           // 'Cut Away Only' | 'Cut Away / Hardware'
    remedialPlannedOutage: null,             // 'Yes' | 'No'
    remedialTrafficManagement: null,         // 'Yes' | 'No'
    remedialCustomerNotification: null,      // 'Yes' | 'No'
    remedialWaspUpdate: null,                // 'Yes' | 'No'
    remedialAssetAgreement: null,            // 'Yes' | 'No'
    remedialWorkInstructions: '',            // 'free text'
    caseNumber: '',                          // 'free text'
}

export default function DlspRemedialAssessmentForm({ remedialDetails, qaComments, statusHistory, icpNumber, assignee, onClose }) {
    const [showAlert, setShowAlert] = useState(false)
    const [remedialData, setRemedialData] = useState(false)


    const { handleSubmit, control, formState: { errors }, setValue, watch, /* reset, getValues, trigger */ } = useForm({ defaultValues: initialFormState });
    const watchAllFields = watch()

    const {
        isLoading: remedialSaving,
        load: saveRemedial,
    } = useFetchJson('/bff/decommissioned-lines-service/api/decommissioned-lines/submit-remedial', { method: 'POST' })

    useEffect(() => {
        if (remedialDetails?.remedialWorkInstructions) {
            setValue('remedialWorkInstructions', remedialDetails?.remedialWorkInstructions)
            console.log('working!!')
        } else {
            setValue('remedialWorkInstructions', `
${qaComments}`)
        }

        //
        // Triggers on start-up or assessment details change to pre-fill form fields
        // 
        if (remedialDetails) {
            // QA Audit
            setValue('remedialAssetAgreement', remedialDetails.remedialAssetAgreement)
            setValue('remedialCustomerNotification', remedialDetails.remedialCustomerNotification)
            setValue('remedialPlannedOutage', remedialDetails.remedialPlannedOutage)
            setValue('caseNumber', remedialDetails.caseNumber)
            setValue('remedialTrafficManagement', remedialDetails.remedialTrafficManagement)
            setValue('remedialWaspUpdate', remedialDetails.remedialWaspUpdate)
            // setValue('remedialWorkInstructions', workInstructions)
            setValue('workers', remedialDetails.workers)

            // updateStatusHelperTextAndOptionalFields(fieldQADetails.nextStatus)

        }
    }, [remedialDetails, qaComments, setValue])


    const onSubmit = async (data) => {
        setRemedialData(data)
        if(data.caseNumber){
            setShowAlert(true)
        }else{
            sendToSalesforce(data)
        }       
    }

    const sendToSalesforce =async (data)=>{
        console.log('DlspRemedialForm onSubmit data', data)
        const remedialOptions = {
            params: {
                icp: icpNumber,
            },
            body: JSON.stringify(data)
        }
        console.log("remedialOptions: ", remedialOptions)
        const theAssessmentResponse = await saveRemedial(remedialOptions)
        if (theAssessmentResponse !== undefined) {
            //
            // Field QA form was saved successfully and status was updated. 
            //

            onClose() // tell parent component we're done
        }
    }

    return (
        <Card sx={{ my: 2, p: 2 }}>
            <AlertDialog
                open={showAlert}
                title={"You have entered in a case number"}
                content={"This will change the task status to FSP and the task will become uneditable."}
                leftLabel={"No"}
                onLeftClick={() => setShowAlert(false)}
                rightLabel={"Yes"}
                onRightClick={() => sendToSalesforce(remedialData)}
                onClose={() => setShowAlert(false)}
            />
            <ReactHooksFormWrapper
                onSubmit={handleSubmit(onSubmit)}
                control={control}
                errors={errors}
                submitLabel="Save FSP Instructions"
                isSubmitting={remedialSaving}
                submittingLabel="Saving FSP Instructions..."
            >

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <SelectRequiredControl
                            control={control}
                            errors={errors}
                            fieldName={'workers'}
                            fieldLabel="Work Type"
                            options={RemedialWorkCrew}
                            controlSx={{ minWidth: '80%' }}
                        /> <br />
                        <RadioGroupRequiredControl control={control} errors={errors} fieldName={'remedialPlannedOutage'}
                            fieldLabel="Planned Outage *" controlSx={{ my: 2 }} options={yesNoOptions}
                        /> <br />
                        <RadioGroupRequiredControl control={control} errors={errors} fieldName={'remedialTrafficManagement'}
                            fieldLabel="Traffic Management *" controlSx={{ my: 2 }} options={yesNoOptions}
                        /> <br />
                        <RadioGroupRequiredControl control={control} errors={errors} fieldName={'remedialCustomerNotification'}
                            fieldLabel="Customer Notification *" controlSx={{ my: 2 }} options={yesNoOptions}
                        /> <br />

                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <RadioGroupRequiredControl control={control} errors={errors} fieldName={'remedialWaspUpdate'}
                            fieldLabel="Wasp Update *" controlSx={{ my: 2 }} options={yesNoOptions}
                        /> <br />
                        <RadioGroupRequiredControl control={control} errors={errors} fieldName={'remedialAssetAgreement'}
                            fieldLabel="Asset Agreement *" controlSx={{ my: 2 }} options={yesNoOptions}
                        /> <br />
                        <Box sx={{ mb: 0 }}>
                            <TextAreaRequiredControl control={control} errors={errors} fieldName={'remedialWorkInstructions'}
                                fieldLabel="Work Instructions" controlSx={{ width: '100%', mt: 0 }}
                                minRows={5} maxRows={5} placeholder='Instructions...'
                            />
                            <FormHelperText sx={{ mt: -1 }}>{'These comments are instructions to Northpower Contracting'}</FormHelperText>
                        </Box>
                        <TextFieldControl controlSx={{ width: '100%' }} control={control} errors={errors} fieldName={'caseNumber'} fieldLabel={'Salesforce Case Number'} placeholder="E.g. 00057161" />

                    </Grid>
                </Grid>
                <DebugBox title="errors" stringify>{errors}</DebugBox>
                <DebugBox title="watchAllFields" stringify>{watchAllFields}</DebugBox>
            </ReactHooksFormWrapper>
        </Card>
    )
}
